import { render, staticRenderFns } from "./GetLink.vue?vue&type=template&id=3fa70cc8&"
import script from "./GetLink.vue?vue&type=script&lang=js&"
export * from "./GetLink.vue?vue&type=script&lang=js&"
import style0 from "./GetLink.vue?vue&type=style&index=0&id=3fa70cc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VImg,VTextField})
